import { CheckCircle2, Hourglass, XCircle } from 'lucide-react'
import type { BadgeTone } from '@/components/ui'
import { Badge } from '@/components/ui'
import { EventStatus } from '@/lib/constants'

const MAP: Record<
  string,
  { tone: BadgeTone; icon: React.ReactNode; label: string }
> = {
  [EventStatus.Verified]: {
    tone: 'emerald',
    icon: <CheckCircle2 size={13} />,
    label: 'Vérifié',
  },
  [EventStatus.NotVerified]: {
    tone: 'gold',
    icon: <Hourglass size={13} />,
    label: 'En attente',
  },
  [EventStatus.SoftDelete]: {
    tone: 'danger',
    icon: <XCircle size={13} />,
    label: 'Supprimé',
  },
}

export default function StatusPill({ status }: { status: string }) {
  const m = MAP[status] ?? MAP[EventStatus.NotVerified]
  return (
    <Badge tone={m.tone} iconLeft={m.icon}>
      {m.label}
    </Badge>
  )
}
